import React from "react";
import style from "../../Styles/Components/HistoryList.module.css";

import HistoryCard from "./HistoryCard";
import {dateUtil} from "../../Lib/Utils";

const HistoryList = ({ histories, type, handleModal=null, ELocale }) => (
  <div className={style.container}>
    {histories &&
      histories.map(( history , index) => (
        <HistoryCard title={history.title}
                     date={ELocale === 'kr' ? dateUtil.format("YYYY년 M월 D일, a H:mm", new Date(history.createdAt)) : dateUtil.format("llll", new Date(history.createdAt))}
                     marginTop={index !== 0 && 8} type={type}
                     eventPrize={history.eventPrize}
                     companyLogoUrl={history.companyLogoUrl}
                     handleModal={() => {
                       if (handleModal) {
                         handleModal(history)
                       }
                     }}
                     key={index}
                     ELocale={ELocale}
        />
      ))}
  </div>
);

export default HistoryList;
